import React, { useEffect, useRef, useState } from "react";
import Table from "../react-table/Table";
import {
  userOrderStatsTableColumns,
  userWalletStatsTableColumns,
} from "../../utils/reactTableColumns";
import { getErrors } from "../../utils/handler.utils";

function UserStatistics() {
  const tabs = [
    { key: "orders", label: "Order List" },
    { key: "wallet", label: "Wallet Balance" },
  ];
  const [activeTab, setActiveTab] = useState(tabs[0].key);
  const [orderTotal, setOrderTotal] = useState(null);
  const [walletTotal, setWalletTotal] = useState(null);
  const orderReloadRef = useRef(null);
  const walletReloadRef = useRef(null);
  const [orderRange, setOrderRange] = useState("");

  useEffect(() => {
    setOrderRange("");
  }, [activeTab]);

  const renderTabs = () => {
    return (
      <div className="flex gap-3 border-b mb-4">
        {tabs.map((tab) => (
          <button
            key={tab.key}
            type="button"
            onClick={() => setActiveTab(tab.key)}
            className={`px-4 py-2 font-semibold transition-colors ${
              activeTab === tab.key
                ? "border-b-2 border-blue-500 text-blue-600"
                : "text-gray-500 hover:text-gray-700"
            }`}
          >
            {tab.label}
          </button>
        ))}
      </div>
    );
  };

  const selectOrders = (res) => {
    const users =
      res?.data?.data?.users || res?.data?.data || res?.data?.users || [];
    const total = res?.data?.data?.user_count;

    setOrderTotal(total);

    return {
      data: users,
      total,
    };
  };

  const selectWallets = (res) => {
    const users =
      res?.data?.data?.users || res?.data?.data || res?.data?.users || [];
    const total = res?.data?.data?.user_count;

    setWalletTotal(total);

    return {
      data: users,
      total,
    };
  };

  return (
    <div className="md:px-5">
      <div className="bg-white py-5 mb-5 px-5">
        {renderTabs()}

        {activeTab === "orders" ? (
          <Table
            key="orders"
            customGlobalSearch={({ addSearchParam, removeSearchParam }) => {
              return (
                <OrdersRangeFilter
                  range={orderRange}
                  setRange={setOrderRange}
                  addSearchParam={addSearchParam}
                  removeSearchParam={removeSearchParam}
                />
              );
            }}
            reloadRefFunc={orderReloadRef}
            tableTitle="User Order Statistic"
            tableSubTitle={
              orderTotal !== null ? `Total result: ${orderTotal}` : ""
            }
            tableId="user_order_stat_table"
            url="/admin/highest-order-by-user"
            selectData={selectOrders}
            selectError={(err) => getErrors(err, true)[0]}
            columns={userOrderStatsTableColumns}
          />
        ) : (
          <Table
            key="wallet"
            reloadRefFunc={walletReloadRef}
            tableTitle="User Wallet Balance"
            tableSubTitle={
              walletTotal !== null ? `Total result: ${walletTotal}` : ""
            }
            tableId="user_wallet_stat_table"
            url="/admin/highest-wallet-by-user"
            selectData={selectWallets}
            selectError={(err) => getErrors(err, true)[0]}
            columns={userWalletStatsTableColumns}
          />
        )}
      </div>
    </div>
  );
}

function OrdersRangeFilter({
  range,
  setRange,
  addSearchParam,
  removeSearchParam,
}) {
  useEffect(() => {
    if (range) addSearchParam("range", range);
    else removeSearchParam("range");
  }, [range]);

  return (
    <div className="w-full md:w-[200px]">
      <select
        className="form_input mb-0"
        value={range}
        onChange={(e) => setRange(e.target.value)}
      >
        <option value="">All Time</option>
        <option value="1">Last 1 Day</option>
        <option value="3">Last 3 Days</option>
        <option value="7">Last 7 Days</option>
        <option value="15">Last 15 Days</option>
      </select>
    </div>
  );
}

export default UserStatistics;
